import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import ReadOnlyInputControl from './ReadOnlyInputControl';
import { useFormSelector } from '../../custom-hooks';
import { getUITA, isTrue } from '../../utils/commonUtils';
import { isNilOrEmpty } from '../../utils/ramdaUtils';
import { fetchDataSource } from '../actions/data-source.actions';
import { PREDEFINED_DATA_SOURCES, SS_CONTROL_TYPE } from '../constants/form-manager.constants';
import { getDataSource } from '../selectors/form-manager.selectors';
import {
  getDataSourceWatchValues,
  getMultiSelectDropDownValues,
} from '../selectors/runtime.selectors';
import { equalityFn } from '../utils/form-manager.utils';
import { getValueByDataSourceTextField } from '../utils/runtime.utils';

function ViewOnlyDataSourceControl({
  label,
  value,
  dataSourceKey,
  dataValueField,
  dataTextField,
  dataSourceFilter,
  inTable,
  index,
  inFieldGroup,
  isHiddenLabel,
  formKey,
  id,
  entityName,
  fieldName,
  controlType,
  isDetail,
  multiSelect,
}) {
  const dispatch = useDispatch();
  const dataSource = useFormSelector(getDataSource, { dataSourceKey }, equalityFn) || {};
  const watchValues = useFormSelector(
    getDataSourceWatchValues,
    {
      conditions: dataSourceFilter?.Conditions || [],
      dataSource,
      index,
      entityName,
    },
    equalityFn
  );
  const supportsMultipleOptions = isTrue(multiSelect);
  const multiSelectValues = useFormSelector(
    getMultiSelectDropDownValues,
    { entityName, fieldName, index, supportsMultipleOptions },
    equalityFn
  );
  const [values, setValues] = useState([]);
  const pageLimit = controlType === SS_CONTROL_TYPE.RADIO_BUTTON_LIST ? 1 : undefined;
  const valueStr = _.isNil(value) ? '' : value.toString();

  const dataValue = supportsMultipleOptions
    ? multiSelectValues
        .map((val) => getValueByDataSourceTextField(values, val, dataTextField, dataValueField))
        .join(', ')
    : getValueByDataSourceTextField(values, valueStr, dataTextField, dataValueField);

  useEffect(() => {
    if (!isNilOrEmpty(dataSource) && !PREDEFINED_DATA_SOURCES.includes(dataSourceKey)) {
      dispatch(
        fetchDataSource({
          index,
          dataSource,
          dataSourceFilter,
          dataSourceFilterFromDataSource: dataSource?.filter,
          formKey,
          pageLimit,
          entityName,
          isEditor: false,
        })
      ).then((vals) => setValues(vals));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...watchValues]);

  useEffect(() => {
    if (PREDEFINED_DATA_SOURCES.includes(dataSourceKey) && dataValueField && dataTextField) {
      const _values = dataSource?.map(({ Id, Name, TranslatedName }) => ({
        Id,
        Name: TranslatedName ?? Name,
      }));
      setValues(_values);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ReadOnlyInputControl
      uita={getUITA(controlType.replace('ss', 'SS'), entityName, fieldName)}
      label={label}
      value={dataValue}
      inTable={inTable}
      isDetail={isDetail}
      isHiddenLabel={isHiddenLabel}
      inFieldGroup={inFieldGroup}
      entityName={entityName}
      fieldName={fieldName}
      id={id}
      index={index}
      controlType={controlType}
    />
  );
}

export default ViewOnlyDataSourceControl;
